// extracted by mini-css-extract-plugin
module.exports = {"appRoot":"style_appRoot__2vnsy"};